module.exports = __webpack_public_path__ + "static/20181117_141856_optimized-549057279c01e9327bb1d519cda5e52c.jpg";